//libs
import { styled } from '@nykaa/ui-components';

//constants
import { BASE_GUTTER_SPACE, FOCUS_VISIBILITY_CSS } from 'shared/styles/base';

//components
import ImageV2 from 'shared/components/ImageV2';

export const Container = styled.div`
  &:first-child {
    margin-top: ${({ theme }) => theme.spacing.spacing120};
  }
`;
export const CustomTitle = styled.p`
  ${({ theme }) => theme.typography.subTitleSmall};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: 0;
  margin-top: 0;
`;

export const CustomSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => `${theme.spacing.spacing80} 0`};
`;

export const ItemName = styled.div`
  ${({ theme }) => theme.typography.bodyLarge};
  color: ${({ theme }) => theme.colors.textPrimary};
`;
export const ItemSubtext = styled.div`
  color: ${({ theme }) => theme.colors.textSecondary};
  ${({ theme }) => theme.typography.bodyMedium}
  margin-top: ${({ theme }) => theme.spacing.spacing20};
`;

export const SectionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
  cursor: pointer;
  
  ${FOCUS_VISIBILITY_CSS}
  
  &:last-child {
    border-bottom: none;
    padding-bottom: ${({ theme }) => theme.spacing.spacing120};
  }
  &.with-rewards {
    border-bottom: none;
  }
`;

export const TopSectionContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  
  ${FOCUS_VISIBILITY_CSS}
  
  &:last-child {
    border-bottom: none;
  }
`;
export const CustomIconContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  width: ${BASE_GUTTER_SPACE * 3}px;
`;

export const ImageContainer = styled(ImageV2)``;

export const TopWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.textOutline};
`;

export const MFAContainer = styled.div`
  padding-bottom: ${({ theme }) => `${theme.spacing.spacing80}`};
`;

export const RewardsDetails = styled.div`
  display: flex;
`;

export const RewardsIcon = styled.div`
  flex: 0.1;
  position: relative;
  margin-right: 0.75rem;
`;

export const RewardsTitle = styled.div`
  padding-bottom: ${({ theme }) => `${theme.spacing.spacing80}`};
  flex: 0.85;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.buttonSmall};
`;

export const RewardsDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const CustomTitleRewards = styled(CustomTitle)`
  padding: 16px 16px 16px 0;
  color: ${({ theme }) => theme.colors.textPrimary};
  ${({ theme }) => theme.typography.buttonMedium};
`;

export const RewardsDetailsIcon = styled(ImageV2)`
  width: 32px;
  height: 32px;
  position: absolute;
  top: -8px;
`;
